/**
 * Create a lab manifest object.
 *
 * @param {Object} props
 * @param {string} props.id
 * @param {string} props.displayName
 * @param {string} props.labAreaUnlockPassageId
 * @param {string} props.completionPassageId
 * @param {Object[]} props.passages
 * @returns {import("@/types/labManifest.types.js").LabManifest}
 */
export const createLabManifest = ({
  id,
  displayName,
  labAreaUnlockPassageId,
  completionPassageId,
  passages
}) => {
  const passageIds = passages.map((p) => p.id);
  const progressSteps = passages
    .filter((p) => p.progressLabel)
    .map((p) => ({ id: p.id, label: p.progressLabel }));
  return {
    id,
    displayName,
    labAreaUnlockPassageId,
    completionPassageId,
    passageIds,
    progressSteps
  };
};
